import { useState } from 'react'
import styled from 'styled-components'

import { useTranslation } from '@root/shared/localization'
import { Drawer, SegmentControl } from '@root/shared/ui-kit'

import { TradingPositionsList } from './trading-positions-list'
import { TradingTransactionList } from './trading-transactions-list'

import type { DrawerControlProps } from '@root/shared/ui-kit'

type Tab = 'positions' | 'transactions'

type PositionsExpandedContentProps = {} & DrawerControlProps

export const PositionsDrawer: React.FC<PositionsExpandedContentProps> = ({
  open,
  onOpenChange,
}) => {
  const [tab, setTab] = useState<Tab>('positions')
  const { t } = useTranslation()

  const renderContent = () => {
    if (tab === 'transactions') {
      return <TradingTransactionList />
    }

    return <TradingPositionsList />
  }

  return (
    <Root
      title={t('trading.navigation.positions')}
      open={open}
      onOpenChange={onOpenChange}
    >
      <Content>
        <Header>
          <SegmentControl value={tab} onChange={setTab}>
            <SegmentControl.Item value={'positions' satisfies Tab}>
              {t('position_other')}
            </SegmentControl.Item>
            <SegmentControl.Item value={'transactions' satisfies Tab}>
              {t('transaction_other')}
            </SegmentControl.Item>
          </SegmentControl>
        </Header>

        {renderContent()}
      </Content>
    </Root>
  )
}

const Root = styled(Drawer)`
  height: var(--max-drawer-height);
`

const Content = styled.div`
  display: grid;

  height: 100vh;
  grid-template-rows: auto minmax(0, 1fr);
  gap: 14px;

  overflow: hidden;
`

const Header = styled.div`
  display: grid;
  justify-content: center;
`
